import React from 'react';
import { Icon, Tag, Tooltip } from '@fourthwall/components';
import { QuestionMarkIcon } from '@fourthwall/icons';
import * as S from './DomainStatusTag.styled';
export const tagPropsMap = {
    REMOVAL_IN_PROGRESS: { label: 'Removal in progress', appearance: 'critical' },
    SYNCING_YOUR_DOMAIN: { label: 'Syncing your domain', appearance: 'default' },
    CONNECTED: { label: 'Connected', appearance: 'success' },
    PARTIALLY_CONNECTED: { label: 'Partially Connected', appearance: 'success' },
    NOT_CONNECTED: { label: 'Not connected', appearance: 'alert' },
    CONNECTING: { label: 'Connecting', appearance: 'alert' },
};
export const DomainStatusTag = ({ status }) => {
    const tagProps = tagPropsMap[status];
    return (React.createElement(S.Container, null,
        React.createElement(Tag, { ...tagProps }),
        status === 'REMOVAL_IN_PROGRESS' && (React.createElement(Tooltip, { reference: React.createElement(Icon, { component: QuestionMarkIcon, height: 18.75 }), placement: "top", fluid: true }, "This process usually takes a couple of seconds"))));
};
